<template>
  <!--begin::Widget 3-->
  <div class="chart d-flex flex-column align-items-center">
    <div class="chart-header">
      <span class="font-size-h5">CO₂</span>
    </div>
    <div class="chart-body d-flex flex-column align-items-center" :class="{ blur: !collectYn }">
      <div class="chart-svg">
        <div class="chart-icon">
          <span class="svg-icon svg-icon-success">
            <inline-svg
              src="https://s3.ap-northeast-2.amazonaws.com/static.s3.plantee/tfarmon/media/svg/icons/Weather/Fog.svg"
            ></inline-svg>
          </span>
        </div>
        <apexchart
            :options="chartOptions"
            :series="series"
            type="radialBar"
          ></apexchart>
      </div>
      <div class="chart-value">
        <span v-if="collectYn" class="font-weight-bolder font-size-h2">{{ co2 }}</span>
        <span v-else class="font-size-h2">{{ co2 }}</span>
      </div>
    </div>
    <div v-if="!collectYn" class="d-flex flex-column align-items-center mt-30 overlay">
      <i class="flaticon-cancel icon-3x mb-3"></i>
      <div>데이터 미수집</div>
    </div>
  </div>
  <!--end::Widget 3-->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Widget3",
  props: {
    co2: Number,
    collectYn: Boolean
  },
  data() {
    return {
      chartOptions: {}
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    series() {
      return [this.co2]
    }
  },
  mounted() {
    // reference; kt_stats_widget_7_chart
    this.chartOptions = {
      chart: {
        zoomType: 'x,y',
        height: 200,
        type: "radialBar"
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: "65%"
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: false,
              fontWeight: "700"
            },
            value: {
              color: this.layoutConfig("colors.dark"),
              fontSize: "25px",
              fontWeight: "700",
              offsetY: 100,
              show: false
            }
          },
          track: {
            background: this.layoutConfig("colors.theme.light.success"),
            strokeWidth: "100%"
          }
        }
      },
      colors: [this.layoutConfig("colors.theme.base.success")],
      stroke: {
        lineCap: "round"
      },
      labels: ["Progress"]
    };
  }
};
</script>
